import { render, staticRenderFns } from "./AddProductComponent.vue?vue&type=template&id=f469764e"
import script from "./AddProductComponent.vue?vue&type=script&lang=js"
export * from "./AddProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports